
import ReportEntity from "../../report/entity";
import * as bootstrap from 'bootstrap'
import TicketOverviewShow from "./show";
import TicketShowReports from "./show/reports";
import TicketShowDocuments from "./show/documents";
import TicketShowOrders from "./show/orders";
import TicketShowLogs from "./show/logs";
import TicketShowChildren from "./show/children";
import TicketShowServicesBSM from "./show/services_bsm";
import Utils from '../../../utils'
import Quill from 'quill'
import SignaturePad from "signature_pad"

export default class TicketOverviewShowBSM extends TicketOverviewShow {
    private workReportEditor: Quill;
    private signaturePad: SignaturePad | undefined;
    addChilds() {
        this.childs = {
            services: new TicketShowServicesBSM(this),
            reports: new TicketShowReports(this),
            documents: new TicketShowDocuments(this),
            orders: new TicketShowOrders(this),
            logs: new TicketShowLogs(this),
            children: new TicketShowChildren(this)
        }

        this.workReportEditor = new Quill('#modal_report_description ', {
            bounds: '#modal_report_description',
            placeholder: Utils.translate("ticket.chat.placeholder"),
            modules: {
                toolbar: '#snow-modal-report-toolbar'
            },
            theme: 'snow'
        });
    }
    bindListeners() {
        super.bindListeners();

        (document.querySelector("#ticketWorkReportModalForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();

            const modal = bootstrap.Modal.getOrCreateInstance((document.querySelector("#ticketWorkReportModal") as HTMLElement))
            const form = document.querySelector("#ticketWorkReportModalForm") as HTMLFormElement;
            const entityData = ReportEntity.getEntityData(form);
            console.log(entityData);
            await Utils.entity.upsert({...entityData, description: this.workReportEditor.root.innerHTML}, "reports");
            this.toastr.success(`${Utils.translate('report.name')} ${Utils.translate('generic.saved')}`, `${Utils.translate('generic.success')}`)

            await this.getEntity();
            modal.hide();

        });


        (document.querySelector("#ticketWorkReportModalSignForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();

            const modal = bootstrap.Modal.getOrCreateInstance((document.querySelector("#ticketWorkReportModalSign") as HTMLElement))
            const form = document.querySelector("#ticketWorkReportModalSignForm") as HTMLFormElement;
            if (this.signaturePad) {
                const image = this.signaturePad.toDataURL();
                await Utils.entity.upsert({uuid: (form.querySelector("#report_uuid") as HTMLInputElement).value, signature: image}, "reports");
            }
            this.toastr.success(`${Utils.translate('report.name')} ${Utils.translate('generic.saved')}`, `${Utils.translate('generic.success')}`)
            await this.getEntity();
            modal.hide();

        });

        jQuery(".chat-history-wrapper").delegate(".button_workreport_edit", "click", async (e: any) => {
            e.preventDefault();
            const modal = bootstrap.Modal.getOrCreateInstance((document.querySelector("#ticketWorkReportModal") as HTMLElement))
            const id = e.target.getAttribute("data-id");
            const report = await Utils.entity.get(id, "reports")
            const form = document.querySelector("#ticketWorkReportModalForm") as HTMLFormElement;
            await Utils.updateElements(report.data[0], '', form)

            if (report.data[0].arrival_resource) {
                const $newOption1 = jQuery("<option selected='selected'></option>").val(report.data[0].arrival_resource.uuid).text(report.data[0].arrival_resource.name)
                jQuery("#ticketWorkReportModalForm #report_arrival_resource_id").append($newOption1).trigger('change');
            }
            if (report.data[0].return_resource) {
                const $newOption2 = jQuery("<option selected='selected'></option>").val(report.data[0].return_resource.uuid).text(report.data[0].return_resource.name)
                jQuery("#ticketWorkReportModalForm #report_return_resource_id").append($newOption2).trigger('change');
            }
            this.workReportEditor.pasteHTML(report.data[0].description)
            modal.show();
        });

        jQuery(".chat-history-wrapper").delegate(".button_workreport_sign", "click", async (e: any) => {
            e.preventDefault();
            const modal = bootstrap.Modal.getOrCreateInstance((document.querySelector("#ticketWorkReportModalSign") as HTMLElement))
            const id = e.target.getAttribute("data-id");
            const report = await Utils.entity.get(id, "reports")
            const data = report.data[0]
            if (data.signed) {

            } else {
                const form = document.querySelector("#ticketWorkReportModalSignForm") as HTMLFormElement;
                await Utils.updateElements(data, '', form)
                const canvas = document.querySelector('#ticketWorkReportModalSignCanvas') as HTMLCanvasElement | null;
                if (canvas) {
                    if (!this.signaturePad) {
                        this.signaturePad = new SignaturePad(canvas);
                    } else {
                        this.signaturePad.clear();
                    }
                }
                modal.show();
            }
        })
    }
    parseComments(data: any) {
        let entries: { type: string; at: any; body: string; }[] = []
        data.logs.forEach((log: any) => {
            if (log.changes && log.changes.length > 0) {

                entries.push({
                    type: "log",
                    at: log.created_at,
                    body: this.addLog(log)
                })
            }
        });
        data.reports.forEach((report: any) => {
            entries.push({
                type: "report",
                at: report.created_at,
                body: this.addReport(report)
            })
        });
        data.comments.forEach((comment: any) => {
            entries.push({
                type: "comment",
                at: comment.created_at,
                body: this.addComment(comment)
            })
        });
        console.log("entries", entries)
        // @ts-ignore
        entries = entries.sort((a, b) => {
            if (new Date(Date.parse(a.at)).getTime() > new Date(Date.parse(b.at)).getTime()) {
                return 1;
            } else if (new Date(Date.parse(a.at)).getTime() < new Date(Date.parse(b.at)).getTime()) {
                return -1;
            } else {
                return 0;
            }
        });
        console.log("entries", entries)

        let html = `<div class="row">`
        entries.reverse().forEach((entry: any) => {
            html += entry.body;
        })
        html += `</div>`;
        this.chatHistoryBody.innerHTML = html;
    }

    processChatAdd(r: any) {
        const html = this.addComment(r.data[0])
        this.chatHistoryBody.innerHTML = html + this.chatHistoryBody.innerHTML
    }

    addLog(log: any) {
        let html = '';
        html += `<div class="col-12 mb-4">
            <div class="card" style="border-top: 5px solid rgba(153, 159, 255, 0.4)">
            <div class="card-body">`
        html += `<b style="margin-bottom: 10px;">${log.user.name} at ${Utils.formatDate(log.created_at)}</b><br />`

        html += log.changes.join("<br />")
        html += `</div> </div> </div>`
        return html
    }

    addReport(report: any) {
        let html = '';
        html += `<div class="col-12 mb-4">
            <div class="card" style="border-top: 5px solid rgba(255, 72, 72, 0.4)">
            <div class="card-body">`
        html += `<div class="row d-flex justify-content-between">
<div class="col-3"> <b style="margin-bottom: 10px;">${report.user.name} at ${Utils.formatDate(report.created_at)}</b></div>
<div class="col-3" style="text-align: right;">
${!report.signed ? `<button data-id="${report.uuid}" class="btn btn-primary button_workreport_sign" style="margin-right: 5px;" data-signed="${report.signed}">Sign</button><button data-id="${report.uuid}" class="btn btn-primary button_workreport_edit">Edit</button>` : `<a role="button" href="/api/v1/reports/${report.uuid}/download" target="_blank" class="btn btn-success">Download</a>`}</div></div>`
        let attachmentHtml = 'No attachments available.'
        if (report.attachments.length > 0) {
            attachmentHtml = ''
            report.attachments.forEach((attachment: any) => {
                if (attachment.url.indexOf(".png") !== -1 || attachment.url.indexOf(".jpg") !== -1 || attachment.url.indexOf(".jpeg") !== -1) {
                    attachmentHtml += ` <a href='${attachment.url}' target="_blank"><img style="max-height: 100px;" src="${attachment.url}" class="img-fluid" /></a>`
                } else {
                    attachmentHtml += `<a href='${attachment.url}' target="_blank">${attachment.name}</a>`
                }
            });
        }
        html += `
                    <div class="row mb-4">
                        <div class="col-6"> 
                            <h4>Description</h4>
                            ${report.description}
                        </div> 
                        <div class="col-6"> 
                            <h4>Attachments</h4>
                            ${attachmentHtml}
                        </div> 
                    </div>
                    <div class="row mb-4">
                        <div class="col-3"> 
                            <h4>Appointment</h4>
                            ${report.calendar_appointment ? `${Utils.formatDate(report.calendar_appointment.from)}` : 'Not bound to an appointment.'}
                        </div> 
                        <div class="col-3"> 
                            <h4>Arrival</h4>
                            ${Utils.formatDate(report.arrival_from)} - ${Utils.formatDate(report.arrival_to)} (${report.arrival_time}min)<br />${report.arrival_resource ? `${report.arrival_resource.name}, ` : ``}${report.arrival_distance ? `${report.arrival_distance}km` : ``}
                        </div> 
                        <div class="col-3"> 
                            <h4>Work</h4>
                            ${Utils.formatDate(report.spent_from)} - ${Utils.formatDate(report.spent_to)} (${report.spent_time}min)
                        </div> 
                        <div class="col-3"> 
                            <h4>Return</h4>
                            ${Utils.formatDate(report.return_from)} - ${Utils.formatDate(report.return_to)} (${report.return_time}min)<br />${report.return_resource ? `${report.return_resource.name}, ` : ``}${report.return_distance ? `${report.return_distance}km` : ``}
                        </div> 
                    </div>`
        html += `</div> </div> </div>`
        return html
    }

    addComment(comment: any) {
        let html = '';
        html += `<div class="col-12 mb-4">
            <div class="card" style="border-top: 5px solid ${comment.internal ? 'rgba(255, 217, 78, 0.4)' : 'rgba(10, 197, 50, 0.4)'}">
            <div class="card-body">
        <div class="row"><div class="col-6">`
        if (comment.origin) {
            html += `<b style="margin-bottom: 10px;">${comment.from} at ${Utils.formatDate(comment.created_at)} | <a href="/${(<any>window).currentLocale}/ticket/tasks/${comment.origin.uuid}">${comment.origin.title_formatted}</a></b><br />`
        } else {
            html += `<b style="margin-bottom: 10px;">${comment.from} at ${Utils.formatDate(comment.created_at)}</b><br />`
        }
        html += `</div><div class="col-6" style="text-align: right"><b>${comment.internal ? '<button class="btn btn-xs btn-primary" style="border-color: rgba(255, 217, 78, 0.4); background-color: rgba(255, 217, 78, 0.4)">Intern</button>' : '<button class="btn btn-xs btn-primary" style="border-color: rgba(10, 197, 50, 0.4); background-color: rgba(10, 197, 50, 0.4)">Extern</button>'}</b></div></div>`

        html += comment.description
        if (comment.attachments.length > 0) {
            const image_types = ["image/png", "image/jpeg", "image/svg+xml"]
            comment.attachments.forEach((attachment: any) => {
                const url = attachment.url;
                if (image_types.indexOf(attachment.type) !== -1) {
                    html += `<br /><img src="${url}" style="height: 120px;cursor: pointer;" class="img-thumbnail ticket_comment_img"/>`
                } else {
                    html += `${attachment.name}<br /><a href="${url}" target="_blank"><button class="btn btn-secondary"><i style="color:#FFF;" class="ti ti-download"></i>  Download</button> </a>`
                }
            })
        }
        html += `</div> </div> </div>`
        return html;
    }

    setupScrollbars() {
        //noop
    }
}